import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const rorePriceTypes = [
  {
    path: 'pricetypes',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Price Types')
      },
      permissions: ['READ_RORE_PRICE_TYPES']
    },
    children: [
      {
        path: '',
        name: 'rorePriceTypesList',
        component: wrapLegacyRoute('rorePriceTypesController', 'list')
      },
      {
        path: 'create',
        name: 'rorePriceTypeCreate',
        component: wrapLegacyRoute('rorePriceTypesController', 'create')
      },
      {
        path: ':priceTypeId(\\d+)',
        name: 'rorePriceTypeDetails',
        component: wrapLegacyRoute('rorePriceTypesController', 'details')
      }
    ]
  }
];

export default rorePriceTypes;
